module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar uptool",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请输入内容",
      "size": "small"
    },
    model: {
      value: (_vm.inputMore),
      callback: function($$v) {
        _vm.inputMore = $$v
      },
      expression: "inputMore"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "请选择"
    },
    slot: "prepend",
    model: {
      value: (_vm.selectMore),
      callback: function($$v) {
        _vm.selectMore = $$v
      },
      expression: "selectMore"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "内部ID/任务单号",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "设备ID",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Mac地址",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.Find
    },
    slot: "append"
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("快速筛选:\n          ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "所有颜色",
      "size": "small"
    },
    on: {
      "change": _vm.Quickfind
    },
    model: {
      value: (_vm.Color),
      callback: function($$v) {
        _vm.Color = $$v
      },
      expression: "Color"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有颜色",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "黑金",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "白红",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "白灰",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "样机",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "钢铁侠",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "酒红",
      "value": "7"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "纯黑",
      "value": "8"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "鸟蓝",
      "value": "9"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "粉白",
      "value": "10"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "白色",
      "value": "257"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "红色",
      "value": "258"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "所有版本",
      "size": "small"
    },
    on: {
      "change": _vm.Quickfind
    },
    model: {
      value: (_vm.Ver),
      callback: function($$v) {
        _vm.Ver = $$v
      },
      expression: "Ver"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有版本",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "标准版",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动舒适版",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动基本版",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动豪华版",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动工伤版",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动旗舰版",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "电动推杆",
      "value": "7"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动lite版",
      "value": "8"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "所有气弹簧",
      "size": "small"
    },
    on: {
      "change": _vm.Quickfind
    },
    model: {
      value: (_vm.Spring),
      callback: function($$v) {
        _vm.Spring = $$v
      },
      expression: "Spring"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有气弹簧",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "800",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "600",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未知",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.Refresh
    }
  }, [_vm._v("刷新")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading),
      expression: "listloading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.List,
      "border": "",
      "max-height": _vm.maxHeight
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50",
      "selectable": _vm.checkboxInit
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Did",
      "prop": "did"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mac",
      "prop": "mac"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "颜色",
      "prop": "color"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "版本",
      "prop": "edition"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "气弹簧",
      "prop": "spring"
    }
  }), _vm._v(" "), (_vm.Limits.warehoused_receipt) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.receipt_date == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.Makesure(scope.$index, scope.row, scope.column)
            }
          }
        }, [_vm._v("确认入库\n          ")]) : _vm._e(), _vm._v(" "), (scope.row.receipt_date != 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success",
            "disabled": ""
          }
        }, [_vm._v("已确认")]) : _vm._e()]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar downtool",
    attrs: {
      "span": 24
    }
  }, [(_vm.Limits.warehoused_deliver) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": this.sels.length === 0,
      "size": "small"
    },
    on: {
      "click": _vm.OpenClear
    }
  }, [_vm._v("出货\n      ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.delivered_index) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ShowIn
    }
  }, [_vm._v("显示已出货设备")]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.Pagesize,
      "current-page": _vm.Curpage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "出货",
      "visible": _vm.ChuVisible,
      "top": "5%",
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.ChuVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "inline": false,
      "model": _vm.Cform,
      "rules": _vm.rules,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "智能识别",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入收货信息，形如：“张三 13262508070  北京市东城区长安街”"
    },
    model: {
      value: (_vm.autoinputmsg),
      callback: function($$v) {
        _vm.autoinputmsg = $$v
      },
      expression: "autoinputmsg"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-edit-outline"
    },
    on: {
      "click": _vm.AutoInput
    },
    slot: "append"
  }, [_vm._v("自动填入")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出货流水",
      "label-width": "100px",
      "prop": "liushui"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入正确的11位流水号",
      "maxlength": 11
    },
    model: {
      value: (_vm.Cform.liushui),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "liushui", $$v)
      },
      expression: "Cform.liushui"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货日期",
      "label-width": "100px",
      "prop": "cct"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.Cform.cct),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "cct", $$v)
      },
      expression: "Cform.cct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货地区",
      "label-width": "100px",
      "prop": "ssq"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.Addoptions,
      "expand-trigger": "hover"
    },
    model: {
      value: (_vm.Cform.ssq),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "ssq", $$v)
      },
      expression: "Cform.ssq"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "label-width": "100px",
      "prop": "xxdz"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写详细地址"
    },
    model: {
      value: (_vm.Cform.xxdz),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "xxdz", $$v)
      },
      expression: "Cform.xxdz"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": false,
      "model": _vm.Cform,
      "rules": _vm.rules2,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人",
      "label-width": "100px",
      "prop": "getperson"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写收货人姓名(不超过5个字)",
      "maxlength": 5
    },
    model: {
      value: (_vm.Cform.getperson),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "getperson", $$v)
      },
      expression: "Cform.getperson"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人电话",
      "label-width": "100px",
      "prop": "getphone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写收货人联系方式",
      "maxlength": 20
    },
    model: {
      value: (_vm.Cform.getphone),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "getphone", $$v)
      },
      expression: "Cform.getphone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经销商",
      "label-width": "100px",
      "prop": "jxs"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择经销商（不填则默认“上海邦邦机器人有限公司”）"
    },
    model: {
      value: (_vm.Cform.jxs),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "jxs", $$v)
      },
      expression: "Cform.jxs"
    }
  }, _vm._l((_vm.Dealerlist), function(item) {
    return _c('el-option', {
      key: item.index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.Cform,
      "rules": _vm.rules3,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出货人",
      "label-width": "100px",
      "prop": "person"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写出货人姓名(不超过5个字)",
      "maxlength": 5
    },
    model: {
      value: (_vm.Cform.person),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "person", $$v)
      },
      expression: "Cform.person"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备类别",
      "label-width": "100px",
      "prop": "kind"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择设备类别"
    },
    model: {
      value: (_vm.Cform.kind),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "kind", $$v)
      },
      expression: "Cform.kind"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "终端客户（个人）",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "终端客户（单位）",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "经销商客户（购销）",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "经销商客户（押金）",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "公司内部（市场）",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "公司内部（研发）",
      "value": "7"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": "4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "size": "mini"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.OutList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Did",
      "width": "250",
      "prop": "did"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "textarea",
            "autosize": "",
            "placeholder": "请输入内容",
            "maxlength": 50
          },
          model: {
            value: (scope.row.remark),
            callback: function($$v) {
              _vm.$set(scope.row, "remark", $$v)
            },
            expression: "scope.row.remark"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.ChuVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.UpOutloading
    },
    on: {
      "click": _vm.Chuhuo
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "已出货设备",
      "visible": _vm.OutVisible,
      "fullscreen": true
    },
    on: {
      "update:visible": function($event) {
        _vm.OutVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar uptool",
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    staticStyle: {
      "width": "15rem"
    },
    attrs: {
      "placeholder": "输入设备DID",
      "size": "small"
    },
    model: {
      value: (_vm.shippedDid),
      callback: function($$v) {
        _vm.shippedDid = $$v
      },
      expression: "shippedDid"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.queryShippedDid
    },
    slot: "append"
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading2),
      expression: "listloading2"
    }],
    attrs: {
      "data": _vm.List2,
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "DID",
      "prop": "did"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "MAC",
      "prop": "mac"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "颜色",
      "prop": "color",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "气弹簧",
      "prop": "spring",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "版本",
      "prop": "edition",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "流水号",
      "prop": "deliveryOrder.serial_number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货日期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.chuTimeFormatter(scope.row.deliveryOrder.delivery_date)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "经销商",
      "prop": "dealer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出货地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.deliveryOrder.shipping_prov == '无') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t无\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.deliveryOrder.shipping_prov != '无') ? _c('span', [_c('span', [_vm._v(_vm._s(scope.row.deliveryOrder.shipping_prov))]), _vm._v(" "), (scope.row.deliveryOrder.shipping_city != scope.row.deliveryOrder.shipping_prov) ? _c('span', [_vm._v(_vm._s(scope.row.deliveryOrder.shipping_city))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.deliveryOrder.shipping_dist))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.deliveryOrder.shipping_addr))])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收货人",
      "prop": "deliveryOrder.receiver"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出货人",
      "prop": "deliveryOrder.shipper",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "prop": "deliveryOrder.remark"
    }
  }), _vm._v(" "), (_vm.Limits.warehoused_receipt) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.confirmRefundDevice(scope.$index, scope.row, scope.column)
            }
          }
        }, [_vm._v("\n              退货\n            ")])]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.Pagesize2,
      "current-page": _vm.Curpage2,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "补充退货信息",
      "visible": _vm.showRefundInfoDialog,
      "before-close": _vm.handleRefundInfoDialogClose,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showRefundInfoDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "refundForm",
    attrs: {
      "model": _vm.refundInfo,
      "rules": _vm.refundInfoRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "退货接收时间",
      "label-width": "100px",
      "prop": "return_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "220px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "date",
      "size": "mini",
      "editable": false,
      "clearable": true,
      "format": "yyyy/M/d",
      "value-format": "timestamp",
      "placeholder": "请选择收到退货设备的日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.refundInfo.return_date),
      callback: function($$v) {
        _vm.$set(_vm.refundInfo, "return_date", $$v)
      },
      expression: "refundInfo.return_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退货原因",
      "label-width": "100px",
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入退货原因（不超过50字）"
    },
    model: {
      value: (_vm.refundInfo.reason),
      callback: function($$v) {
        _vm.$set(_vm.refundInfo, "reason", $$v)
      },
      expression: "refundInfo.reason"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检测结论",
      "label-width": "100px",
      "prop": "detection_result"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入设备检验结果（不超过100字）"
    },
    model: {
      value: (_vm.refundInfo.detection_result),
      callback: function($$v) {
        _vm.$set(_vm.refundInfo, "detection_result", $$v)
      },
      expression: "refundInfo.detection_result"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经办人",
      "label-width": "100px",
      "prop": "agent"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入退货经办人姓名（不超过10字）"
    },
    model: {
      value: (_vm.refundInfo.agent),
      callback: function($$v) {
        _vm.$set(_vm.refundInfo, "agent", $$v)
      },
      expression: "refundInfo.agent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showRefundInfoDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.doRefundDevice
    }
  }, [_vm._v("退 货")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78b341d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/WarehousingEquipment.vue
// module id = 1287
// module chunks = 1